// Angular
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { inject, Injectable } from "@angular/core";

// Services
import { AuthService } from "#services/auth/auth.service";

// Others
import { AUTH_PATH } from "#src/app/shared/variables/routes";

@Injectable({
    providedIn: "root",
})
export class AuthGuard implements CanActivate {
    private readonly authService = inject(AuthService);
    private readonly router = inject(Router);

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        const isLoggedIn = await this.authService.isLoggedIn();

        if (state.url === `/${AUTH_PATH}`) {
            if (isLoggedIn && typeof window !== "undefined") {
                this.router.navigate(["/"]);
            }

            return true;
        }

        if (isLoggedIn) {
            return true;
        }

        this.router.navigate([`/${AUTH_PATH}`], {
            skipLocationChange: true,
        });

        return false;
    }
}
